import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__collections } from '../STATE__collections';

export const local_collection_upsert = (payload: DTO__collection[]): PayloadAction<DTO__collection[]> => ({
  type: ENUM__redux_action.COLLECTION_UPSERT,
  payload,
});

export const init_local_collection_upsert = (state: STATE__collections, action: PayloadAction<DTO__collection[]>) => {
  if (action.payload.is_empty()) return;

  let items = action.payload;

  for (let item of items) {
    state.collections_map.set(item._id, item);

    if (item.type == ENUM__workspace_entity.COLLECTION_CUSTOM) {
      state.custom_collections_map.set(item._id, item);
    }

    if (state.collection_favorites._id == item._id) {
      state.collection_favorites = item;
    }

    if (state.collection_generated._id == item._id) {
      state.collection_generated = item;
    }

    if (state.collection_uploads._id == item._id) {
      state.collection_uploads = item;
    }

    if (state.collection_viewed_on_search._id == item._id) {
      state.collection_viewed_on_search = item;
    }
  }

  //need to force re-render
  state.collections_map = new Map(state.collections_map);
  state.custom_collections_map = new Map(state.custom_collections_map);
};
